module.exports = __webpack_public_path__ + "static/media/domahubWeb.a77bbf08.jpg";